<template>
  <div class="g-header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GHeader'
}
</script>

<style scoped>
.g-header {}
</style>
